"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppVersion = void 0;
const util_1 = require("../util");
const util_2 = require("../util");
const UnsupportedVersion_1 = __importDefault(require("../../UnsupportedVersion"));
const currentAppVersion = process.env.REACT_APP_APP_VERSION;
const OK = { Component: null, appVersion: currentAppVersion };
const useAppVersion = () => {
    const previousAppVersion = (0, util_2.getAppVersionUpdateInProgress)();
    if (previousAppVersion) {
        if (previousAppVersion !== currentAppVersion) {
            (0, util_1.removeAppVersionUpdateInProgress)();
            return OK;
        }
        return { Component: UnsupportedVersion_1.default, appVersion: currentAppVersion };
    }
    return OK;
};
exports.useAppVersion = useAppVersion;
